import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);
const STORAGE_KEY = "apx_assessment_v1";

const EMPTY = { safety: null, vision: null, pattern: null, muscular: null, report: null };

// Read once from localStorage on first load so assessment data survives reloads,
// tab reopens, and — critically — the sign-up / sign-in redirect step.
function hydrate() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw);
    return { ...EMPTY, ...parsed };
  } catch {
    return EMPTY;
  }
}

export function AssessmentProvider({ children }) {
  const [data, setData] = useState(hydrate);

  // Persist every change so the flow is fully resumable after auth
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      /* quota exceeded or private mode — ignore */
    }
  }, [data]);

  const update = (key, value) => setData((d) => ({ ...d, [key]: value }));
  const reset = () => {
    setData(EMPTY);
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  };

  return <Ctx.Provider value={{ data, update, reset, setData }}>{children}</Ctx.Provider>;
}

export const useAssessment = () => useContext(Ctx);
